import chartConfig, {
  EX_EXCHANGE,
  EX_SECURITY_TYPE,
  LIMIT_RENDER_COUNT,
} from "./chartConfig"
import { setChartSession, getChartSession } from "./chartSession"
import _ from "lodash"

interface Window {
  Logic: any
}

declare var window: Window

export const setSymbolAndLegs = (
  term: string,
  symbol: any,
  _provider: any,
  _controller: any,
  renderCount = LIMIT_RENDER_COUNT
) => {
  if (_provider) {
    _provider.Suspend()
    _provider.UnRegistCh()
  }
  if (!_controller || _.isEmpty(symbol)) return
  let barType = getBarType(term)
  const reqParam = {
    securityType: symbol.SecurityType,
    symbol: symbol.Symbol,
    exchange: symbol.Exchange,
    interval: 60,
    count: renderCount,
    legType: term,
    saveKey: undefined as any,
    symbolkey: "main",
  }
  const numberOfDecimals = symbol.NumberOfDecimals
  const session = chartSession(symbol.SecurityType, symbol.Exchange)
  if (!session) {
    setChartSession()
    // return alert("ログインしなおしてください")
  }
  _controller.SetData2.call(null, [
    reqParam,
    symbol.SymbolName ? symbol.SymbolName : symbol.SymbolNameS,
    barType,
    session,
    window.Logic.Helper.toSome(numberOfDecimals),
    window.Logic.Helper.toSome(LIMIT_RENDER_COUNT),
  ])
  if (_provider) _provider.Resume()
}

export const setSubSymbol = (
  term: string,
  plotType: string,
  chartKey: number,
  symbol: any,
  renderCount: number,
  _provider: any,
  _controller: any
) => {
  if (!_controller || plotType === "PandF") return
  let barType = getBarType(term)
  const reqParam = {
    securityType: symbol.SecurityType,
    symbol: symbol.Symbol,
    exchange: symbol.Exchange,
    interval: 60,
    count: LIMIT_RENDER_COUNT,
    legType: term,
    saveKey: undefined as any,
    symbolkey: `sub${chartKey}`,
  }
  const numberOfDecimals = symbol.NumberOfDecimals
  const session = chartSession(symbol.SecurityType, symbol.Exchange)
  if (!session) {
    setChartSession()
    return false
  }
  return _controller.AddSubData.call(null, [
    reqParam,
    symbol.SymbolName ? symbol.SymbolName : symbol.SymbolNameS,
    barType,
    session,
    window.Logic.Helper.toSome(numberOfDecimals),
    window.Logic.Helper.toSome(LIMIT_RENDER_COUNT),
  ])
}

export const removeSubSymbol = (node: any, _controller: any) => {
  if (!node) return
  _controller.RemoveSubData.call(null, node)
}

const chartSession = (SecurityType: number, Exchange: number) => {
  if (SecurityType === EX_SECURITY_TYPE) Exchange = EX_EXCHANGE
  if (SecurityType === undefined || Exchange === undefined) return null
  const key = SecurityType.toString() + "@" + Exchange.toString()
  // let ss = config.chart.ChartSessions
  // console.log(ss)
  const chartSession = getChartSession()
  return chartSession[key]
}

const getBarType = (term: string) => {
  let barType = null
  switch (term) {
    case "1m":
      barType = window.Logic.Helper.toBarMin(1)
      break
    case "5m":
      barType = window.Logic.Helper.toBarMin(5)
      break
    case "30m":
      barType = window.Logic.Helper.toBarMin(30)
      break
    case "1D":
      barType = window.Logic.Helper.toBarDay()
      break
    case "1W":
      barType = window.Logic.Helper.toBarWeek()
      break
    case "1M":
      barType = window.Logic.Helper.toBarMonth()
      break
    case "3m":
      barType = window.Logic.Helper.toBarMin(3)
      break
    case "10m":
      barType = window.Logic.Helper.toBarMin(10)
      break
    case "15m":
      barType = window.Logic.Helper.toBarMin(15)
      break
    case "20m":
      barType = window.Logic.Helper.toBarMin(20)
      break
    case "60m":
      barType = window.Logic.Helper.toBarMin(60)
      break
    default:
      break
  }
  return barType
}
